export default __webpack_public_path__ + "static/ggzsHoverMb-1efdfa711ef9cb267093b58aca631756.png";